import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button
} from '@mui/material';
import {
  Folder
} from '@mui/icons-material';
import './FolderSelectionDialog.css';

const FolderSelectionDialog = ({ open, onClose, onFolderSelect }) => (
  <Dialog 
    open={open} 
    onClose={onClose}
    PaperProps={{
      className: 'folder-dialog-paper'
    }}
  >
    <DialogTitle className="folder-dialog-title">
      Select Binder
    </DialogTitle>
    <DialogContent className="folder-dialog-content">
      <Typography variant="body2" className="folder-dialog-description">
        Choose a binder containing PDF files. All PDF files in the binder will be uploaded.
      </Typography>
      <Button
        variant="contained"
        startIcon={<Folder sx={{ fontSize: 18 }} />}
        onClick={onFolderSelect}
        fullWidth
        className="browse-folder-btn"
      >
        Browse Binder
      </Button>
    </DialogContent>
    <DialogActions className="folder-dialog-actions">
      <Button 
        onClick={onClose}
        className="cancel-btn"
      >
        Cancel
      </Button>
    </DialogActions>
  </Dialog>
);

export default FolderSelectionDialog;
